<script setup>
import {computed, onMounted, ref, watch} from "vue";
import store from "@/store";
import {couponConf} from "@/utils/config";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";
import LoginComponents from "@/components/login/LoginComponents.vue";
import XmLogin from "@/components/login/xmLogin.vue";

const type = computed(() => {
  let pay = store.state.coupon
  if (!pay) return {}
  return couponConf[pay]
})
const login = ref(false)
const account = computed(() => {
  return store.state.account
})
const page = ref(1)
const last_page = ref(1)
const orderLst = ref([])
watch(account, (to) => {
  if (to.cust_id) order()
  else login.value = true
})
onMounted(() => {
  store.commit("getCoupon")
  store.dispatch("getAccounts")
  document.title = "兑换记录"
});
const order = () => {
  login.value = false
  let axi_conf = {
    encode: "site",
    method: "coupon/orderLst",
    body: {
      uid: account.value.uid,
      page: page.value,
      business: type.value.type
    },
    score_type: "xm_air"
  }
  if (type.value.type === "jlx") {
    axi_conf.encode = 'coupon'
    axi_conf.method = 'life/orderLst'
    axi_conf.body = {
      type: type.value.type + '-' + type.value.child,
      cust_id: account.value.cust_id,
      page: page.value
    }
  }
  new axiosApi(axi_conf).send((res) => {
    if (res.message.code === "000") {
      orderLst.value = page.value === 1 ? res.data.data : orderLst.value.concat(res.data.data)
      last_page.value = res.data.last_page
    }
  })
}
const score = ref()
const scrollbar = (refs) => {
  let warp = refs.wrapRef;
  const poor = warp.scrollHeight - warp.clientHeight;
  if (poor === parseInt(warp.scrollTop) || poor === Math.ceil(warp.scrollTop) || poor === Math.floor(warp.scrollTop)) {
    if (page.value < last_page.value) {
      page.value++;
      order()
    }
  }
}

const typeWait = ord => {
  if (type.value.type === 'sqwl' || type.value.type === 'meland' || type.value.type === 'meland-scal') {
    router.replace({name: 'home', query: {order: ord.ordersn}})
  } else {
    router.replace({name: 'success', params: {order: ord.ordersn}})
  }
}
const orderCls = computed(() => {
  let cls = type.value.type
  if (type.value.child && type.value.child === 'tm') {
    cls = "tm-mark"
  }
  return cls;
})
</script>

<template>
  <div :style="{backgroundImage: `url('${type.orderBg}')`}"
       style="background-repeat: no-repeat;background-size: 100% auto">
    <div class="page-header page-pid">
      <div @click="router.back()">
        <el-icon>
          <ArrowLeft/>
        </el-icon>
      </div>
      <div>兑换记录</div>
      <div></div>
    </div>
    <el-scrollbar class="page-pid order-list" :style="type.style" v-if="orderLst.length" @scroll="scrollbar(score)"
                  ref="score">
      <div class="order-item" v-for="ord in orderLst" :key="ord.id">
        <el-card style="border-radius: 12px">
          <div class="order-order-sn">
            <div class="order-info">订单编号：{{ ord.ordersn }}</div>
            <div class="order-state">
              <template v-if="type.type !== 'jlx'">
                <span v-if="ord.pay_status === 200 && ord.order_status === 1" style="color: var(--el-color-warning)">已支付</span>
                <span v-if="ord.pay_status === 0 && ord.order_status === 1"
                      style="color: var(--el-color-info)">未支付</span>
                <span v-if="ord.pay_status === 300 || ord.order_status === 2"
                      style="color: var(--el-color-info)">已取消</span>
                <span v-if="ord.pay_status === 500" style="color: var(--el-color-info)">已退款</span>
              </template>
              <template v-else>
                <el-text :type="ord.state === 1?'success':'warning'">{{ ord.state_text }}</el-text>
              </template>
            </div>
          </div>
          <div class="order-contents">
            <div class="order-content-left" :class="orderCls">
              <el-image src="https://images.jifen360.com/hbwl/mini.png" alt="" class="order-content-left-img hbwl" v-if="type.type === 'hbwl'"/>
              <el-image :src="type.miniLogo || ord?.images" alt="" class="order-content-left-img hbwl" v-if="type.type === 'hibake'"/>
              <el-image src="https://images.jifen360.com/haolilai/logo.png" alt="" class="order-content-left-img"
                        v-else-if="type.type === 'haoll'"/>
              <el-image src="https://images.jifen360.com/atl/logo-left.png" alt="" class="order-content-left-img"
                        v-else-if="type.type === 'atl'"/>
              <div v-else-if="type.type === 'lsq'" class="lsq-items">
                <el-image :src="type.product_i"/>
                <div class="price">
                  <sup>
                    <el-text type="danger">￥</el-text>
                  </sup>
                  <el-text type="danger" class="face_value">{{ parseFloat(ord.couponItems.face_value) }}</el-text>
                </div>
              </div>
              <div v-else-if="type.type === 'beiguo'" class="beiguo-item">
                <el-image :src="type.product_i"/>
                <div class="price">
                  <sup>
                    <el-text type="danger">￥</el-text>
                  </sup>
                  <el-text type="danger" class="face_value">{{ parseFloat(ord.couponItems.face_value) }}</el-text>
                </div>
                <div class="tips">
                  <el-text type="danger">石家庄市区门店通用</el-text>
                </div>
              </div>
              <div v-else-if="type.type === 'pyf'" class="pyf-pay-header-face-value">
                <el-image :src="type.product_i" alt="" class="order-content-left-img"/>
                <div class="face-value">
                  <div class="pyf-coupon-price-unit">￥</div>
                  <div class="pyf-coupon-price-money">{{ parseFloat(ord?.couponItems?.face_value) }}</div>
                </div>
              </div>
              <el-image src="https://images.jifen360.com/tm_mark/tm-log.png" alt="" class="order-content-left-img" v-else-if="orderCls === 'tm-mark'"/>
              <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/waijiaoguan/logo.png" alt="" class="order-content-left-img" v-else-if="type.type === 'waijiaoguan'"/>
              <el-image src="https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/yuanzu/product.png" alt="" class="order-content-left-img" v-else-if="type.type === 'lanting-yuanzu'"/>
              <el-image :src="type.miniLogo || ord?.images" alt="" class="order-content-left-img" v-else-if="type.type !== 'meland' && type.type !== 'meland-scal'"/>
<!--              <el-image :src="type.miniLogo || ord?.images" alt="" class="order-content-left-img" v-else-if="type.type === 'waijiaoguan' && type.type !== 'meland-scal'"/>-->
              <el-image :src="type.miniLogo" alt="" class="order-content-left-img" v-else/>
            </div>
            <div class="order-content-right">
              <h4 style="margin-bottom: 10px;color: var(--theme-text-color);font-size: .8rem">
                <span v-if="type.type === 'jd-scal'">
                  {{ ord.couponItems.title || ord.couponItems.name }}
                </span>
                <span v-else-if="type.type === 'sqwl'">
                  {{ ord.couponItems.name }}
                  （{{ ord?.couponItems.title }}）
                </span>
                <span v-else-if="type.type === 'meland' || type.type === 'meland-scal'">MELAND
                  {{ ord.couponItems.name }}
                </span>
                <el-text type="primary" v-else-if="type.type === 'hbwl'">{{ ord.couponItems.name }}</el-text>
                <el-text type="warning" v-else-if="type.type === 'haoll' || type.type === 'atl' || type.type==='hibake'">{{ ord.couponItems.name }}</el-text>
                <el-text v-else-if="type.type === 'hkl'">{{ ord.couponItems.title }}</el-text>
                <el-text v-else-if="type.type === 'jlx'">{{ ord.goodsItems.goods_name }}</el-text>
<!--                <el-text v-else-if="type.type === 'lanting-yuanzu'">{{ ord.goodsItems.goods_name }}</el-text>-->
                <el-text v-else :class="orderCls">{{ ord.couponItems.name }}</el-text>
              </h4>
              <div class="order-details">
                <div class="order-details-label">支付{{ type.login === 'xm_air' ? '积分' : '里程' }}</div>
                <div class="order-details-value">
                  {{
                    ord.pay_score || ord.miles
                  }}{{ type.login === 'xm_air' ? '积分' : '里程' }}
                  <span v-if="ord?.couponItems?.pay_score !== ord.total_price && type.type !== 'meland' && ord?.buy_count === 1">(活动价)</span>
                </div>
              </div>
              <div class="order-details">
                <div class="order-details-label">{{ type.login === 'xm_air' ? '下单时间' : '兑换时间' }}</div>
                <div class="order-details-value">{{ ord.ctime || ord.create_time }}</div>
              </div>
              <div class="order-details" v-if="type?.type !== 'lanting-yuanzu'">
                <div class="order-details-label">{{ type.type === 'meland' ? '收货手机号' : '充值账户' }}</div>
                <div class="order-details-value">{{ ord.mobile }}</div>
              </div>
              <div class="order-details" v-if="type.login === 'xm_air'">
                <div class="order-details-label">付款账户</div>
                <div class="order-details-value">厦门航空白鹭会员账户</div>
              </div>
              <div class="order-details" v-if="ord.pay_status === 200 && type.type === 'jd-scal'">
                <div class="order-details-label">使用状态</div>
                <div class="order-details-value">
                  <span v-if="ord.used === 0">已过期</span>
                  <span v-if="ord.used === 1 || ord.used === 3">
              <el-button link type="primary"
                         @click="typeWait(ord)">去使用</el-button>
            </span>
                  <span v-if="ord.used === 2 && ord.pay_status === 200">已使用</span>
                  <!--                  <span v-if="ord.used === 2 && ord.pay_status !== 200">支付异常</span>-->
                </div>
              </div>
              <div class="order-details"
                   v-if="ord.pay_status === 200 && ['sqwl','meland','meland-scal','hkl','lsq','pyf','beiguo','atl','hibake','waijiaoguan','lanting-yuanzu'].some(item => type.type === item) && ord.order_status === 1">
                <div class="order-details-label">兑换券码</div>
                <div class="order-details-value">
                  <el-button round :type="type.login === 'xm_air'?'primary':'danger'" link @click="typeWait(ord)">
                    查看券码
                  </el-button>
                </div>
              </div>
              <div class="order-details"
                   v-if="ord.pay_status === 200 && (type.type === 'hbwl' || type.type==='haoll') ">
                <div class="order-details-value">
                  <el-button round :type="type.login === 'xm_air'?'primary':'danger'"
                             @click="router.replace({name:'success',params:{order: ord.ordersn}})" size="small">
                    查看卡号和卡密
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </el-scrollbar>
    <el-empty description="暂无订单" v-else/>
  </div>

  <login-components v-if="login && type.login === 'scal'" :show-login="login" @login="order"/>
  <xm-login v-if="login && type.login === 'xm_air'" :show-login="login" @login="order"/>
</template>

<style scoped lang="less">
.page-header {
  height: 45px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
}

.order-list {
  height: calc(100vh - 65px);
  overflow-x: hidden;

  /deep/ .el-card__body {
    padding: 10px 20px;
    box-sizing: border-box;
  }

  .order-item {
    margin: 0 20px 15px;

    .el-card {
      background-image: url("@/assets/images/order-body.png");
      background-repeat: no-repeat;
      background-position: right bottom;
      background-size: 45px 45px;
    }

    .order-order-sn {
      position: relative;
      padding: 10px 0;
      border-bottom: var(--el-border);
      margin-bottom: 10px;

      & > .order-info:after {
        content: '';
        position: absolute;
        height: 20px;
        left: -20px;
        width: 5px;
        background: var(--text-color);
        display: inline-block;
      }

      .order-state {
        position: absolute;
        right: -20px;
        height: 20px;
        line-height: 20px;
        background: var(--text-color);
        //color: #ffffff;
        padding: 5px 15px 5px 25px;
        border-radius: 45px 0 0 45px;
        top: 5px;
      }
    }
  }

  .order-contents {
    display: flex;
    align-items: center;
    gap: 10px;

    .order-content-left {
      width: 100px;
      flex-basis: 100px;
      //margin-right: 10px;
      text-align: center;

      .el-image {
        width: 65%;

        &.hbwl {
          width: 100px;
        }
      }

      &.tm-mark{
        background: #6DC43D;
        height: 85px;
        position: relative;
        border-radius: 10px;

        .el-image{
          position: absolute;
          top: 50%;
          width: 85%;
          transform: translate(-50%,-50%);
        }
      }

      &.waijiaoguan{
        position: relative;
        height: 85px;
        background: #56B6C2;
        border-radius: 8px;

        .el-image{
          position: absolute;
          top: 50%;
          width: 85%;
          transform: translate(-50%,-50%);
        }


      }
      &.lanting-yuanzu{
        .el-image{
          width: 100%;
        }
      }
      &.haoll{
        background: #dedede;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 15px;

        .el-image{
          width: 100%;
        }
      }

      &.atl{
        background: #7862A9;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 15px;
      }

      &.pyf{
        .pyf-pay-header-face-value {
          flex-basis: 100px;
          box-sizing: border-box;
          padding: 8px;
          background: #FAFAFA;
          border-radius: 8px;
          position: relative;
          width: 100px;
          margin-right: 10px;

          .el-image{
            width: 100%;
          }

          .face-value {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 20px;
            color: #CF392E;
            font-weight: 600;

            .pyf-coupon-price-unit {
              font-size: .6rem;
            }

            .pyf-coupon-price-money {
              font-size: 1.65rem;
            }
          }
        }
      }

      .lsq-items {
        position: relative;
        background: #F5F5F5;
        box-sizing: border-box;
        padding: 5px;
        border-radius: 5px;

        .el-image {
          width: 100%;
        }

        .price {
          position: absolute;
          left: 0;
          right: 0;
          text-align: center;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          //align-content: ;
          justify-content: center;

          .face_value {
            font-size: 1.95rem;
          }

          sup {
            margin-top: 3px;
          }
        }
      }
      &.beiguo{
        flex-basis: 140px;
        width: 140px;
        .beiguo-item {
          position: relative;
          background: #F5F5F5;
          box-sizing: border-box;
          padding: 8px;
          border-radius: 5px;

          .el-image {
            width: 100%;
          }
          //
          .price {
            position: absolute;
            left: 0;
            right: 0;
            text-align: center;
            top: 18%;
            //transform: translateY(-15%);
            //bottom: 50px;
            display: flex;
            //align-content: ;
            justify-content: center;

            .face_value {
              font-size: 1.95rem;
            }

            sup {
              margin-top: 3px;
            }
          }

          .tips{
            position: absolute;
            //禁止換行
            white-space: nowrap;
            //bottom: 18px;
            bottom: 18%;
            left: 0;
            right: 0;
            text-align: center;
            .el-text{
              font-size: .7rem;
            }
          }
        }
      }

      &.sqwl {
        .el-image {
          width: 100%;
        }
      }

      &.meland, &.meland-scal {
        background-color: var(--theme-text-color);
        padding: 30px 10px;
        box-sizing: border-box;
        border-radius: 12px;

        .el-image {
          width: 100%;
        }
      }
    }

    .order-content-right {
      flex-basis: calc(100% - 110px);
      width: calc(100% - 110px);

      .lanting-yuanzu{
        color: var(--price-text);
        font-size: 1rem;
      }

      .order-details {
        display: flex;
        //justify-content: space-between;
        align-items: center;
        //margin-bottom: 15px;
        line-height: 1.75;
        font-size: .85rem;

        .order-details-label {
          //font-weight: 600;
          padding-right: 5px;
        }

        .order-details-value {
          color: var(--el-color-info);
        }
      }
    }

  }

}
</style>
